var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedGns0)",
    d: "M14.961 8.276a.94.94 0 0 1 .467.81v5.828c0 .523-.326.943-.857.943s-.857-.42-.857-.943v-3.63c0-.287-.514-.467-.772-.334l-3.385 1.787a.97.97 0 0 1-1.299-.386a.93.93 0 0 1 .39-1.272l5.37-2.825a.98.98 0 0 1 .943.022"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedGns1)",
    d: "M9.428 10.65c.772-.227 1.329-.248 1.95-.248c.913 0 1.586.23 1.83.514c.163.043.506.184.506.368v3.63c0 .523.326.943.857.943s.857-.42.857-.943V9.086a.93.93 0 0 0-.471-.81a.99.99 0 0 0-.947-.022z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedGns2)",
    d: "M12.467 9.06c.484.129 1.247.467 1.247 1.226v.973c0-.009 0 .008 0 0v3.634c0 .514.326.964.857.964s.857-.42.857-.943V9.086a.93.93 0 0 0-.471-.81a.99.99 0 0 0-.947-.022z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedGns3)",
    d: "m11.014 13.907l-1.072.626c-.154.09-.227.274-.132.428c.124.206.334.468.634.66c.308.202.638.245.878.236c.163-.013.249-.154.249-.317v-1.31c0-.287-.3-.472-.557-.317z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedGns4)",
    fillRule: "evenodd",
    d: "M12 18.429A6.429 6.429 0 1 0 12 5.57a6.429 6.429 0 0 0 0 12.858m0 .857a7.286 7.286 0 1 0 0-14.572a7.286 7.286 0 0 0 0 14.572",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedGns0",
    x1: 18.137,
    x2: 7.382,
    y1: 4.712,
    y2: 14.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#266E84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56DBAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedGns1",
    x1: 13.28,
    x2: 12.351,
    y1: 5.069,
    y2: 19.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2F778D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#43B39C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedGns2",
    x1: 11.82,
    x2: 11.82,
    y1: 4.713,
    y2: 19.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CFB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FC3F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedGns3",
    x1: 11.737,
    x2: 16.749,
    y1: 8.052,
    y2: 19.444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D6C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38BFD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedGns4",
    x1: 8.142,
    x2: 16.285,
    y1: 6.429,
    y2: 18.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CFB8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28CEDD"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGns);
export default __webpack_public_path__ + "static/media/gns.5815eefc08640fddfd91d4065d91ce74.svg";
export { ForwardRef as ReactComponent };